<template>
    <v-dialog @input="(!$event)? category = null : null" :value="category != null && !instaSave" :width="dialogWidth">
        <v-card v-if="category">
            <v-card-title><span v-if="category.id">Edit category</span> <span v-else>{{$t('Add category')}}</span></v-card-title>
            <v-card-text>
                <v-text-field @change="slugCat($event)" v-model="category.name" :label="$t('Category name')"></v-text-field>
                <!--<label>Description</label>
                <trumbowyg v-model="category.description" style="height: 600px" :config="{}" class="form-control" name="content"></trumbowyg>
                <v-checkbox v-model="category.active" label="Active"></v-checkbox>
                <media-picker v-model="category.photo" :show_elements="true"></media-picker>-->
                <v-text-field :label="$t('Category URL')" v-model="category.slug" :rules="[validationRules.required]" :error-messages="errors.slug"></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="save()" color="secondary" dark>{{$t('Save')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import {getCategories, saveCategory, updateCategory, saveOrder} from "../../api/categories";
    const Trumbowyg = () => ({
        component: import('vue-trumbowyg'),
        timeout: 3000
    });
    import {slugify} from "../../helpers";
    import Vue from 'vue';
    import 'trumbowyg/dist/ui/trumbowyg.css';
    export default {
        components: {Trumbowyg},
        data:() => {
            return{
                category:null,
                resolve: null,
                reject: null,
                instaSave: false
            }
        },
        mounted(){
            Vue.prototype.$editAddCategory = this;
        },
        methods:{
            addCategory(data = {}, instaSave = false){
                return new Promise((resolve, reject) => {
                    this.category = data;
                    this.instaSave = instaSave;
                    this.resolve = resolve;
                    this.reject = reject;
                    if(instaSave){
                        this.save();
                    }
                })
            },
            editCategory(data){
                return new Promise((resolve, reject) => {
                    this.category = data;
                    this.resolve = resolve;
                    this.reject = reject;

                })
            },
            slugCat(name){
                this.$set(this.category, 'slug', slugify(name));
            },
            save(){
                this.load = true;
                if(this.category.id){
                    var func = updateCategory(this.category.id, this.category);
                }else{
                    var func = saveCategory(this.category);
                }
                func.then(response => {
                    this.load = false;
                    if(!this.instaSave) this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Completed succesfully'), type: 'success'});
                    this.resolve(response);
                    this.category = null;
                }).catch(e =>{
                    if(!this.instaSave) this.$store.commit('app/ADD_MESSAGE', {text: this.$t('Fields are invalid'), type: 'error'});
                    this.errors = e.response.data.errors;
                    this.reject();
                    this.load = false;
                })
            }
        }
    }
</script>
